import { getStoredFilters, HeaderOptions, updateStoredFilters } from '../common/reports-constants';
import Header from '../../../components/common/global-top-bar';
import SwitchBar from '../../../components/switch-bar';
import { useState } from 'react';
import { EngagementReportFilters } from '../common/reports-constants';
import { useClientSummaryList } from '../../../hooks/useClients';
import { useTAMUReportDownload } from '../../../hooks/useEngagementReporting';

const TAMUReport: React.FC = () => {
  const today = new Date();
  const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [filters, setFilters] = useState<EngagementReportFilters>(() => {
    const defaultFilters: EngagementReportFilters = {
      startDate: firstDayOfCurrentMonth.toISOString().split('T')[0],
      endDate: lastDayOfCurrentMonth.toISOString().split('T')[0],
      clientId: undefined,
    };
    return getStoredFilters(defaultFilters, 'tamuReportFilters');
  });

  const { isFetching: isFetchingCsv, refetch: refetchXlsx } = useTAMUReportDownload(filters, false);
  const handleCsvDownload = () => {
    if (filters.startDate !== '' && filters.endDate !== '') {
      refetchXlsx();
    }
  };

  return (
    <div>
      <Header heading={'TAMU Report'} />
      <SwitchBar heading={HeaderOptions} position={3} />
      <Filters filters={filters} setFilters={setFilters} />
      <div>
        <div className="max-window-height-connections overflow-y-auto px-7 pt-7 font-['Montserrat']">
          <button
            className="bg-blue-primary whitespace-nowrap rounded-full px-4 py-1 text-sm text-white"
            onClick={handleCsvDownload}
            disabled={isFetchingCsv}
          >
            Download Excel Document
          </button>
        </div>
      </div>
    </div>
  );
};

interface FilterProps {
  filters: EngagementReportFilters;
  setFilters: (filters: EngagementReportFilters) => void;
}

const Filters: React.FC<FilterProps> = ({ filters, setFilters }) => {
  const { data: clients } = useClientSummaryList({ show_all_clients: true });
  if (!filters.clientId) {
    const tamuClient = clients?.find((client) => {
      return client.name.toLowerCase().indexOf('Human Behavior Laboratory') > -1;
    });
    if (tamuClient) {
      filters.clientId = tamuClient.id;
    }
  }
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, id } = e.target;
    if (id === 'startDate') {
      setFilters({
        ...filters,
        startDate: value,
      });
      updateStoredFilters('startDate', value, 'tamuReportFilters');
    } else {
      setFilters({
        ...filters,
        endDate: value,
      });
      updateStoredFilters('endDate', value, 'tamuReportFilters');
    }
  };

  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center space-x-2 border-b px-4">
      <div className="gray-background-dark flex items-center py-4"></div>
      <div className="flex items-center space-x-2">
        <label className="whitespace-nowrap text-sm" htmlFor="startDate">
          Start Date:
        </label>
        <input
          id="startDate"
          type="date"
          name="startDate"
          value={filters.startDate}
          onChange={handleDateChange}
          className="w-32 rounded border p-0.5 text-xs focus:ring-transparent"
        />
        <label className="whitespace-nowrap text-sm" htmlFor="endDate">
          End Date:
        </label>
        <input
          id="endDate"
          type="date"
          name="endDate"
          value={filters.endDate}
          onChange={handleDateChange}
          className="w-32 rounded border p-0.5 text-xs focus:ring-transparent"
        />
        <label className="flex items-center whitespace-nowrap text-sm">Client:</label>
        <select
          className="w-full bg-white px-2 text-sm focus:ring-transparent"
          value={filters.clientId}
          onChange={(e) => {
            const { value } = e.target;

            if (value === '') {
              setFilters({ ...filters, clientId: undefined });
            } else {
              setFilters({ ...filters, clientId: parseInt(value) });
            }
          }}
        >
          {clients
            ?.filter((client) => client.packages.length > 0)
            .map((client) => (
              <option key={client.id} value={client.id}>
                {client.name}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default TAMUReport;
